const state = {
  form: {
    product: null,
    product_other_name: '',
    service_start_date: null,
    service_end_date: null,
    cash_total: null, // 現金価格合計
    down_payment: null, // 頭金
    remaining_money: null, // 残金
    finance_category_name: '通常', // 金融商品のカテゴリー名
    payment: null, // 支払方法
    split_number: '', // 分割回数
    bonus_combined_addition_amount: null, //ボーナス併用加算額
    bonus_combined_month1: null, // ボーナス加算月・夏
    bonus_combined_month2: null, // ボーナス加算月・冬
    bonus_combined_number: null, //ボーナス加算回数
    bonus_once_month: null, // 支払月1回目
    bonus_twice_month: null, //支払月2回目
    payment_period_start: null, // 支払期間 開始
    payment_period_end: null, // 支払期間 終了
    payment_amount_once: null, // 支払金額 第1回目
    payment_amount_second: null, // 支払金額 第2回目以降
    split_fee: null, // 分割手数料
    split_total_payment: null, // 分割支払合計
    total_pay: null, // 支払総額
    person_charge: '' // 担当者
  },
  init: {
    // formを初期化するためのobject
    product: null,
    product_other_name: '',
    service_start_date: null,
    service_end_date: null,
    cash_total: null, // 現金価格合計
    down_payment: null, // 頭金
    remaining_money: null, // 残金
    finance_category_name: '通常', // 金融商品のカテゴリー名
    payment: null, // 支払方法
    split_number: '', // 分割回数
    bonus_combined_addition_amount: null, //ボーナス併用加算額
    bonus_combined_month1: null, // ボーナス加算月・夏
    bonus_combined_month2: null, // ボーナス加算月・冬
    bonus_combined_number: null, //ボーナス加算回数
    bonus_once_month: null, // 支払月1回目
    bonus_twice_month: null, //支払月2回目
    payment_period_start: null, // 支払期間 開始
    payment_period_end: null, // 支払期間 終了
    payment_amount_once: null, // 支払金額 第1回目
    payment_amount_second: null, // 支払金額 第2回目以降
    split_fee: null, // 分割手数料
    split_total_payment: null, // 分割支払合計
    total_pay: null, // 支払総額
    person_charge: '' // 担当者
  },
  option: {}, // 金額の計算などに使用するためのオプション(type: Object)
  allOptions: [], // 店舗・加盟店の全ての設定項目
  finances: [], // 金融商品一覧(type: Array)
  list: [], // 商品の一覧
  creditProducts: [], // 信販 商品の一覧
  installmentProducts: [], // 自社割賦 商品の一覧
  validations: [] // php側のバリデーション
}

const getters = {
  getForm(state) {
    return state.form
  },
  getList(state) {
    return state.list
  },
  getCreditProducts(state) {
    return state.creditProducts
  },
  getInstallmentProducts(state) {
    return state.installmentProducts
  },
  getFinances(state) {
    return state.finances
  },
  getOption(state) {
    return state.option
  },
  getAllOptions(state) {
    return state.allOptions
  },
  getValidations(state) {
    return state.validations
  }
}

const mutations = {
  setForm(state, form) {
    if (Object.keys(form).length) {
      for (const key in form) {
        state.form[key] = form[key]
      }
    }
  },
  setList(state, list) {
    // 全商品
    state.list = list

    // 信販用商品
    state.creditProducts = list.filter((product) => product.is_use_credit)

    // 自社割賦用商品
    state.installmentProducts = list.filter((product) => !product.is_use_credit)
  },
  setFinances(state, finances) {
    state.finances = finances
  },
  setOption(state, option) {
    if (Object.keys(option).length) {
      for (const key in option) {
        state.option[key] = option[key]
      }
    }
  },
  setAllOptions(state, allOptions) {
    state.allOptions = allOptions
  },
  // php側のバリデーションエラー更新
  updateValidations(state, validations) {
    state.validations = validations
  }
}

const actions = {
  setForm({commit}, form) {
    commit('setForm', form)
  },
  initForm({commit, state}) {
    commit('setForm', state.init)
  },
  async setList({commit}) {
    await axios.get('/api/store/store/products').then((res) => {
      commit('setList', res.data)
    })
  },
  async setFinances({commit}) {
    await axios.get('/api/store/store/finances').then((res) => {
      commit('setFinances', res.data)
    })
  },
  async setOption({commit}, has_payment) {
    await axios.get('/api/store/store/option').then((res) => {
      commit('setAllOptions', res.data)     // 店舗・加盟店の全ての設定項目
      res.data = res.data.find(x => x.has_payment === has_payment)    // 信販、自社割賦に応じて絞り込み
      commit('setOption', res.data)
    })
  },
  // php側のバリデーションエラー更新
  updateValidations({commit}, validations) {
    commit('updateValidations', validations)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
